import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { UseAuthContext } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { CSVLink } from "react-csv";

export default function ResultTable({ tableData, pageSubmit }) {
    const { t } = useTranslation();
    const { token } = UseAuthContext();
    const [data, setData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [load, setLoad] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [page, setPage] = useState(1);
    const [goto, setGoto] = useState(1);
    const [successMessage, setSuccessMessage] = useState('')
    const [updateValues, setUpdateValues] = useState({
            addressId: '',
            isDeleted: ""
        });

    useEffect(() => {
        setData(tableData.content);
        setPage(tableData.number);
        setGoto(tableData.number + 1);
        setErrMsg("");
    }, [tableData]);

    const csvHeader = [t('result.table.street_name'),
    t('result.table.street_code'),
    t('result.table.building_id'),
    t('result.table.floor'),
    t('result.table.suite'),
    t('result.table.post_code'),
    t('result.table.district'),
    t('result.table.district_subdivision'),
    t('result.table.region'),
    t('result.table.municipality_name'),
    t('result.table.official'),
    t('result.table.deleted')];
    
    const getCsvData = (event, done) => {
        
        if (data.length > 0) {
            setCsvData([csvHeader, ...data.map(d => {
                return [
                    d.accessAddress.streetId.name,
                    d.accessAddress.streetId.code,
                    d.accessAddress.streetBuildingId,
                    d?.floorId,
                    d?.suiteId,
                    d.accessAddress.postCodeId.id,
                    d.accessAddress.postCodeId.districtName,
                    d.accessAddress.districtSubDivId,
                    d.accessAddress.streetId.municipality.region.name,
                    d.accessAddress.streetId.municipality.municipalityName,
                    d.isOfficial,
                    d.isDeleted
                ]
            })]);
        }
        done(true);
    }

    const invalidChars = [
        "-",
        "+",
        "e",
        "."
    ];

    const handleUpdate = () => {
        setLoad(true);
        setErrMsg('');
        setSuccessMessage('');
        //Make an API to pass the address for update
        axios.post(`/api/v1/unofficial-address/${updateValues.addressId}/update?deleteFlag=${updateValues.isDeleted}`, null, { headers: { "Authorization": `Bearer ${token}` } })
        .then(res => {
            console.log('update address', res);
            if (res.data?.message) {
                setSuccessMessage(res.data?.message);
            }
            setLoad(false);
        })
        .catch(err => {
            setErrMsg('An error occured. Please try again.');
            setLoad(false);
        })
        
    }

    const handleSelectAddress = (e, address) => {
        setUpdateValues({addressId: address.id,
            isDeleted: e.target.value
        })
    }

    const officialStatus = {
        "0": "Official",
        "1": "TdcNet Unofficial",
        "8": "Nuuday Unofficial"
    }

    const handleGoto = () => {
        if (goto < 1) {
            setErrMsg(t('result.page_lesser'));
        } else if (goto > tableData.totalPages) {
            setErrMsg(t('result.page_greater'));
        } else {
            pageSubmit(goto - 1)
        }
    }

    return (
        <div className="card-content">
            <div className="row mb-2">
                <div className="col-sm-1 col-2 text-left">
                    <button className="btn btn-primary btn-sm" disabled={page < 1} onClick={() => pageSubmit(page - 1)} ><FontAwesomeIcon icon={faArrowAltCircleLeft} size="xl" /></button>
                </div>
                <div className="col-sm-10 col-8">
                    <div className="form-group row text-center ">
                        <label htmlFor="staticEmail" className="col-sm-2 col-12 col-form-label"> {t('result.page')}: {page + 1} {t('result.of')} {tableData.totalPages}</label>
                        <label htmlFor="staticEmail" className="col-sm-3 col-8 col-form-label text-right"> {t('result.goto')}: </label>
                        <div className="col-sm-2 col-4">
                            <input type="number" className="form-control form-control-sm input-sm" id="page"
                                onKeyDown={(e) => invalidChars.includes(e.key) && e.preventDefault()}
                                value={goto} onChange={(e) => setGoto(e.target.value)} />
                        </div>
                        <div className="col-sm-1 col-12 mb-1">
                            <button className="btn btn-secondary btn-sm " onClick={() => handleGoto()}>{t('result.go')}</button>
                        </div>
                        <div className="col-sm-4 col-12">
                            <CSVLink data={csvData} filename={`nam-address-page-${page}.csv`}
                                asyncOnClick={true}
                                onClick={getCsvData}>
                                <button className="btn btn-sm btn-primary text-right">{t('result.export')} <FontAwesomeIcon icon={faFileExport} /></button>
                            </CSVLink>
                        </div>
                    </div>
                </div>
                <div className="col-sm-1 col-2 text-right">
                    <button className="btn btn-primary btn-sm" disabled={page + 1 >= tableData.totalPages} onClick={() => pageSubmit(page + 1)}><FontAwesomeIcon icon={faArrowAltCircleRight} size="xl" /></button>
                </div>

                <div className="col-12 text-center">
                    {errMsg && <div className="alert alert-danger" style={{ marginBottom: "0", padding: "0.3rem" }} role="alert">{errMsg}</div>}
                </div>
                <div className="col-12 text-center">
                    {successMessage && <div className="alert alert-success" style={{ marginBottom: "0", padding: "0.3rem" }} role="alert">{successMessage}</div>}
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-hover table-sm table-striped table-bordered" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr className="table-active" >                          
                            <th>{t('result.table.street_name')}</th>
                            <th>{t('result.table.street_code')}</th>
                            <th>{t('result.table.building_id')}</th>
                            <th>{t('result.table.floor')}</th>
                            <th>{t('result.table.suite')}</th>
                            <th>{t('result.table.post_code')}</th>
                            <th>{t('result.table.district')}</th>
                            <th>{t('result.table.district_subdivision')}</th>
                            <th>{t('result.table.region')}</th>
                            <th>{t('result.table.municipality_name')}</th>
                            <th>{t('result.table.official')}</th>
                            <th>{t('result.table.deleted')}</th>
                             <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 && data.map((d, i) => <tr key={i}>
                            <td>{d.accessAddress.streetId.name}</td>
                                    <td>{d.accessAddress.streetId.code}</td>
                                    <td>{d.accessAddress.streetBuildingId}</td>
                                    <td>{d?.floorId}</td>
                                    <td>{d?.suiteId}</td>
                                    <td>{d.accessAddress.postCodeId.id}</td>
                                    <td>{d.accessAddress.postCodeId.districtName}</td>
                                    <td>{d.accessAddress.districtSubDivId}</td>
                                    <td>{d.accessAddress.streetId.municipality.region.name}</td>
                                    <td>{d.accessAddress.streetId.municipality.municipalityName}</td>
                                    <td>{officialStatus[d.isOfficial]}</td>
                                    <td>{
                                        <td><select id="isDeleted" className="form-control form-control-sm" defaultValue={d.isDeleted} onChange={(e)=>handleSelectAddress(e, d)}>
                                        <option value="Y" >Y</option>
                                        <option value="N" >N</option>
                                    </select></td>
                                        }</td>
                                    <td><button className="btn btn-secondary btn-sm" disabled={load} onClick={handleUpdate}>{load ? t('search.wait') : 'Update'}</button></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
